import { render, staticRenderFns } from "./home.vue?vue&type=template&id=315774d8&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./home.vue?vue&type=style&index=1&id=315774d8&lang=scss&scoped=true&"
import style2 from "./home.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315774d8",
  null
  
)

export default component.exports